<template>
  <div class="translate-changer" v-click-outside="onClickOutSide">
    <span @click.prevent="showMenu = !showMenu">
      <FlagImage :lang="selectedLang.code" width="30px" class="flag-selected" />
    </span>
    <div v-if="showMenu" class="lang-options">
      <span class="lang-options__arrow"></span>
      <span
        v-for="(lang, i) in otherLang"
        :key="`Lang${i}`"
        @click.prevent="changeLang(lang)"
      >
        <FlagImage
          :lang="lang.code"
          width="30px"
          class="flag-list"
          :alt="lang.code"
        />
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import FlagImage from "@/components/FlagImage/";

export default {
  name: "TranslateSelect",
  components: {
    FlagImage,
  },
  data() {
    return {
      showMenu: false,
      selectedLangCode: "en",
    };
  },
  computed: {
    languages() {
      return this.$store.state.utils.languages;
    },
    selectedLanguageId() {
      return this.$store.state.utils.selectedLanguageId;
    },
    selectedLang() {
      return this.languages.find((lang) => {
        return lang.id === this.selectedLanguageId;
      });
    },
    otherLang() {
      return this.languages.filter((lang) => {
        return lang.id !== this.selectedLanguageId;
      });
    },
  },
  mounted() {
    if (this.$route.query.lang) {
      const LANG_CODE = this.$route.query.lang;
      this.selectedLangCode = LANG_CODE;
      localStorage.LangCode = LANG_CODE;
      this.$i18n.locale = LANG_CODE;

      let lang = this.languages.find((lang) => {
        return lang.code === this.$route.query.lang;
      });

      if (lang) this.setSelectedLanguageId(lang.id);
    } else if (localStorage.LangCode) {
      this.selectLangByCode(localStorage.LangCode);
    } else {
      const LANG_CODE = document.location.href;
      if (LANG_CODE.includes("br")) {
        this.selectLangByCode("pt_br");
      } else if (LANG_CODE.includes("pt")) {
        this.selectLangByCode("pt");
      } else {
        this.selectLangByCode("en");
      }
    }
  },
  methods: {
    ...mapActions("utils", ["setSelectedLanguageId"]),
    changeLang(command) {
      let lang = command;
      this.$i18n.locale = lang.code;
      this.selectedLangCode = lang.code;
      localStorage.LangCode = lang.code;
      this.showMenu = false;

      this.setSelectedLanguageId(lang.id);
    },
    onClickOutSide() {
      this.showMenu = false;
    },
    selectLangByCode(code) {
      this.selectedLangCode = code;
      this.$i18n.locale = code;
      localStorage.LangCode = code;

      const lang = this.languages.find((lang) => {
        return lang.code === code;
      });

      this.setSelectedLanguageId(lang.id);
    },
  },
};
</script>

<style lang="scss" scoped_>
@import "src/assets/css/patterns.scss";

.translate-changer {
  position: relative;
  opacity: 1;
  color: #ccc;
  text-indent: 5px;
  transition: all 0.6s ease;
  z-index: 10000000;
  cursor: pointer;
  gap: 0.5em !important;
  display: flex !important;
  flex-wrap: wrap;
  z-index: 1;

  @media (max-width: 768px) {
    position: absolute;
    right: 20px;
  }

  .lang-options {
    position: absolute;
    justify-content: center;
    align-items: center;
    top: 45px;
    display: flex;
    flex-wrap: wrap;
    background-color: antiquewhite;
    border-radius: 0.5em;
    padding-right: 3px;
    padding-bottom: 3px;

    .lang-options__arrow {
      height: 15px;
      width: 15px;
      background-color: antiquewhite;
      position: absolute;
      top: -5px;
      transform: rotate(45deg);
    }
  }

  span {
    padding: 2px;
    transition: all 0.6s ease;
  }

  .flag-list {
    opacity: 0.8;
  }
}
</style>
